import { connect } from 'react-redux';
import CalendarComp from 'components/CalendarAuth/CalendarAuth';
import icon from '@lifesize/ux-assets/images/webclient/Office-365.svg';
import { injectIntl, defineMessages } from 'react-intl';
import _get from 'lodash/get';
import {
  outlookAuthorize,
  outlookSignout
} from 'actions/Calendar';

const messages = defineMessages({
  outlookCalendar: {
    id: 'components.calendar.outlook',
    defaultMessage: 'Office 365 Calendar'
  },
});

const mapDispatchToProps = dispatch => ({
  signout: () => dispatch(outlookSignout()),
  authorize: redirect => dispatch(outlookAuthorize(redirect))
});

function mapStateToProps(state, { intl }) {
  const isAuthorized = _get(state, 'app.calendar.outlook.calendarSignedIn');
  const accountName = _get(state, 'app.calendar.outlook.calendarUser');
  const calendarName = intl.formatMessage(messages.outlookCalendar);

  return {
    isAuthorized,
    accountName,
    calendarName,
    icon
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CalendarComp)
);
